import React, { useEffect } from "react";
import styles from "./formStep.module.scss";
import CarImg from "../../assets/img/Car.svg";
import OtherImg from "../../assets/img/Other.svg";
import Arrow from "../../assets/img/arrow_right_orange.svg";
import { ModalTitle } from "components/ModalTitle";

export interface FormStepProps {
    children?: any;
    categoryOptions?: any;
    step?: number;
    valueForm: any;
    show?: any;
}

export const TEST_ID = "drop-down-testid";

export const FormStep: React.FC<FormStepProps> = ({
    children,
    step,
    valueForm,
    show,
}) => {
    const [value, setValue] = React.useState(1);
    const [showForm, setShowForm] = React.useState(false);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        setShowForm(true);
    };

    function TabPanel(props) {
        const { children, value, index } = props;

        return (
            showForm && (
                <div
                    className={styles.tab}
                    role="tabpanel"
                    hidden={value !== index}
                >
                    {value === index && children}
                </div>
            )
        );
    }

    interface CategoryProps {
        img: string;
        title: string;
        subtitle: string;
    }

    useEffect(() => {
        setShowForm(show);
    }, [show]);
    useEffect(() => {
        setValue(step);
    }, [step]);

    function Category(props) {
        const { values } = props;
        return values.map((item: CategoryProps, i) => (
            <div
                className={styles.category}
                onClick={(event) => {
                    handleChange(event, i + 1);
                    valueForm(i + 1);
                }}
                key={i}
            >
                <div className={styles.head}>
                    <img src={item.img} alt="" />
                    <span className={styles.title}>{item.title}</span>
                </div>
                <span className={styles.subtitle}>{item.subtitle}</span>
                <div className={styles.arrow}>
                    <img src={Arrow} alt="" />
                </div>
            </div>
        ));
    }

    function CategoryPanel(props) {
        return (
            !showForm && (
                <div className={styles.content}>
                    <ModalTitle
                        title={"Crie seu alerta"}
                        subtitle={"Escolha a categoria do seu novo alerta"}
                    />
                    <div className={styles.box} role="tabpanel">
                        <Category
                            values={[
                                {
                                    img: CarImg,
                                    title: "Carros e Motos",
                                    subtitle:
                                        "Crie alertas para os carros que te interessam",
                                },
                                {
                                    img: OtherImg,
                                    title: "Outros",
                                    subtitle:
                                        "Crie alertas para qualquer produto do seu interesse",
                                },
                            ]}
                        />
                    </div>
                </div>
            )
        );
    }

    useEffect(() => {
        return () => {
            setShowForm(false);
        };
    }, []);

    return (
        <div data-testid={TEST_ID} className={styles.box}>
            <CategoryPanel />

            {[1, 2].map((item, i) => (
                <TabPanel key={i} value={value} index={item}>
                    {step == item && children}
                </TabPanel>
            ))}
        </div>
    );
};
